var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 8.19745C13 8.40127 12.846 8.56688 12.6564 8.56688C12.4668 8.56688 12.3128 8.40127 12.3128 8.19745V7.73885H10.8436V12.2611H11.2701C11.4597 12.2611 11.6137 12.4268 11.6137 12.6306C11.6137 12.8344 11.4597 13 11.2701 13H9.72986C9.54028 13 9.38626 12.8344 9.38626 12.6306C9.38626 12.4268 9.54028 12.2611 9.72986 12.2611H10.1564V7.73885H8.6872V8.19745C8.6872 8.40127 8.53318 8.56688 8.3436 8.56688C8.15403 8.56688 8 8.40127 8 8.19745V7.36943C8 7.16561 8.15403 7 8.3436 7H12.6564C12.846 7 13 7.16561 13 7.36943V8.19745Z",
    fill: "#2E3438",
    stroke: "#2E3438",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    x: 5,
    y: 4.5,
    width: 11,
    height: 11,
    rx: 1.5,
    stroke: "#2E3438"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextInput);
export default __webpack_public_path__ + "static/media/text-input.6c79103962049d165fdb32f1dfa7533d.svg";
export { ForwardRef as ReactComponent };